// ⚠️ DO NOT DELETE commented out rows
// Variant A: Filter-based color fill (active)
// Current implementation: applies dynamic coloring to SVGs using <filter>

import cn from 'classnames'
import Image from 'next/image'
import { FC } from 'react'
import { ImageColorByFilter } from '@/root/ui/shared'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { useConfig } from '@/root/shared-hooks'

interface IconGenericProps extends IconProps {
  type: string
  alt: string
}

const Icon: FC<IconGenericProps> = ({ type, alt, width, height = 0, className, ignoreRtl, color, ...rest }) => {
  const { theme } = useConfig()

  const themePath = `/${theme}/icons/${type}.svg`

  return (
    <div className="flex items-center justify-center">
      <Image
        className={cn(
          {
            'rtl:transform-[rotateY(-180deg)]': !ignoreRtl,
          },
          className
        )}
        alt={alt}
        src={themePath}
        width={width}
        height={height}
        style={{
          filter: color ? `url(#colorFilter-${color})` : 'none',
        }}
        {...rest}
      />
      {color && <ImageColorByFilter color={color} />}
    </div>
  )
}

export default Icon

// ⚠️ DO NOT DELETE

// Variant B: Mask-based color fill (commented out)
// Alternative implementation: applies dynamic coloring via CSS mask/WebkitMask
// Keep for reference if Tailwind-based dynamic coloring is needed

// import cn from 'classnames'
// import Image from 'next/image'
// import { FC } from 'react'
// import { IconProps } from '@/root/shared-types/ui/ui-types'
// import { useConfig } from '@/root/shared-hooks'
// import * as tailwindConfigModule from '@tailwind-config'

// interface IconGenericProps extends IconProps {
//   type: string
//   alt: string
// }

// const resolveTailwindColor = (colorKey?: string) => {
//   if (!colorKey) return undefined

//   const tailwindConfig = ('default' in tailwindConfigModule ? tailwindConfigModule.default : tailwindConfigModule) as {
//     theme?: { colors?: Record<string, string> }
//   }

//   return tailwindConfig.theme?.colors?.[colorKey] ?? colorKey
// }

// const Icon: FC<IconGenericProps> = ({ type, alt, width, height = width, className, ignoreRtl, color, ...rest }) => {
//   const { theme } = useConfig()
//   const src = `/${theme}/icons/${type}.svg`
//   const resolvedColor = resolveTailwindColor(color)

//   const rtlClass = !ignoreRtl ? 'rtl:transform-[rotateY(-180deg)]' : ''

//   if (resolvedColor) {
//     return (
//       <div className={cn('relative flex items-center justify-center', rtlClass, className)} style={{ width, height }}>
//         <span
//           aria-hidden
//           style={{
//             position: 'absolute',
//             inset: 0,
//             backgroundColor: resolvedColor,
//             pointerEvents: 'none',

//             mask: `url(${src}) no-repeat center / contain`,
//             WebkitMask: `url(${src}) no-repeat center / contain`,
//           }}
//         />

//         <Image alt={alt} src={src} width={width} height={height} style={{ opacity: 0 }} {...rest} />
//       </div>
//     )
//   }

//   return <Image className={cn(rtlClass, className)} alt={alt} src={src} width={width} height={height} {...rest} />
// }

// export default Icon
